<template lang="html">

<!--    <div style="width:90%">-->
<!--        &lt;!&ndash;用当前元素来控制高度&ndash;&gt;-->
<!--        <div id="div1" style="height:400px;max-height:500px;">-->
<!--            <p>请输入内容...</p>-->
<!--        </div>-->
<!--    </div>-->

    <div  style="width:100%">
        <div id="div1" ref="editor" style="height:200px;max-height:200px;">
        </div>
    </div>
</template>

<script>
    import E from 'wangeditor'
    export default {
        name: 'editoritem',
        data() {
            return {
                // uploadPath,
                editor: null,
                info_: null,
                isChange:false,
            }
        },
        model: {
            prop: 'value',
            event: 'change'
        },
        props: {
            value: {
                type: String,
                default: ''
            },
            isClear: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            // isClear(val) {
            //     // 触发清除文本域内容
            //     if (val) {
            //         this.editor.txt.clear()
            //         this.info_ = null
            //     }
            // },
            value: function(value) {
                if(!this.isChange){
                    this.editor.txt.html(this.value);
                }
                this.isChange= false;
            }
            //value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
        },
        mounted() {
            this.seteditor()
            this.editor.txt.html(this.value)
        },
        methods: {
            seteditor() {
                this.editor = new E('#div1')
                // 配置菜单
                this.editor.customConfig.menus = []
                this.editor.customConfig.uploadImgHooks = {
                    fail: (xhr, editor, result) => {
                        // 插入图片失败回调
                    },
                    success: (xhr, editor, result) => {
                        // 图片上传成功回调
                    },
                    timeout: (xhr, editor) => {
                        // 网络超时的回调
                    },
                    error: (xhr, editor) => {
                        // 图片上传错误的回调
                    },
                    customInsert: (insertImg, result, editor) => {
                        // 图片上传成功，插入图片的回调
                        //result为上传图片成功的时候返回的数据，这里我打印了一下发现后台返回的是data：[{url:"路径的形式"},...]
                        // console.log(result.data[0].url)
                        //insertImg()为插入图片的函数
                        //循环插入图片
                        // for (let i = 0; i < 1; i++) {
                        // console.log(result)
                        let url = result.url
                        insertImg(url)
                        // }
                    }
                }
                this.editor.customConfig.onchange  = (html) => {
                    this.isChange = true;
                    this.info_ = html // 绑定当前逐渐地值
                    this.$emit('change', this.info_) // 将内容同步到父组件中
                }
                // 创建富文本编辑器
                this.editor.create()
            }
        }
    }
</script>

<style lang="css">
    .editor {
        width: 100%;
        margin: 0 auto;
        position: relative;
        z-index: 0;
    }
    .text {
        border: 0px solid #ccc;
        min-height: 200px;
    }
    .w-e-text-container{
        height: 200px !important;
    }
    .w-e-text{
        height: 200px !important;
    }
</style>